import { useContext, useEffect, useState } from "react";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import { useGetAllDriversQuery } from "../../../../../Redux/service/Drivers/Drivers";
import trans, { isRTL } from "../../../../../utils";
import AntdTable from "../../../../antd/Table/Table";
import { formatDateString } from "../../../../../JsHelpers/DateFormat";

export default function DriversTable({ limit, query, setLimit, setQuery }) {
  const { Sort, setSort: SetSortFilter } = useContext(filtrationcontext);
  const [currentPage, setCurrentPage] = useState(1);

  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  const { data, isLoading, isError } = useGetAllDriversQuery(
    {
      page: currentPage,
      limit: limit,
      search: query,
      sortby: sort.by,
      sortorder: sort.order,
    },
    {
      skip: !currentPage || !limit,
    }
  );

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "id", value: null });
      setLimit(10);
      setQuery("");
      localStorage.setItem("page", 1);
    };
  }, [setLimit, SetSortFilter, setQuery]);

  const columns = [
    {
      title: trans("Name"),
      dataIndex: "name",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
      sorter: true,
      render: (value) => (
        <span className={"table-element-name ps-0"}>{value}</span>
      ),
    },
    {
      title: trans("driver code"),
      dataIndex: "code",
      width: 150,
      sorter: true,
      render: (value) => value || "- - - - -",
    },
    {
      title: trans("ID number"),
      dataIndex: "idNo",
      width: 150,
      render: (value) => value || "- - - - -",
    },
    {
      title: trans("phone number"),
      dataIndex: "phoneNumber",
      width: 150,
      render: (value) => value || "- - - - -",
    },
    {
      title: trans("Address"),
      dataIndex: "address",
      width: 150,
      render: (value) => value || "- - - - -",
    },

    {
      title: trans("Contract Expiry"),
      dataIndex: "contractExpireDate",
      width: 150,
      render: (value) => (value ? formatDateString(value) : "- - - - -"),
    },

    {
      title: trans("License Expiry"),
      dataIndex: "licenseExpire",
      width: 150,
      render: (value) => (value ? formatDateString(value) : "- - - - -"),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="mt-3 table-parent">
      <AntdTable
        columns={columns}
        dataSource={data?.drivers || []}
        loading={isLoading}
        pageSize={limit}
        totalItems={data?.totalCount}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={300}
      />
    </div>
  );
}
